import { mapActions } from 'vuex';
import api from '@/api';
import Card from '@/components/Card/Card';
import Input from '@/components/Input/Input';
import Button from '@/components/Button/Button';
import required from 'vuelidate/src/validators/required';
import email from 'vuelidate/src/validators/email';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';
import Context from '@/models/Context';

export default {
  name: 'Reset',
  components: {
    Card,
    Input,
    Button,
    ToastWrapper
  },
  props: [],
  data() {
    return {
      done: false,
      email: null
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast'
    }),
    reset(e) {
      e.preventDefault();
      const domain = Context.query()
        .where(context => {
          context.id === 'current';
        })
        .first().domain;

      api
        .post(`${domain}/reset`, { username: this.email })
        .then(() => {
          this._newToast({
            text:
              'If your username is found, you will receive an e-mail within a couple of minutes',
            variant: 'good',
            duration: 5000
          });

          this.email = '';
        })
        .catch(error => {
          this._newToast({
            text: 'An error occured while trying to make the request',
            variant: 'danger',
            duration: 2000
          });
        });
    }
  }
};
